import React from 'react';
import styled, { css } from '../../styled/index';
import { CS } from '../../styles/index';
// WRAPPERS
export const Overlay = styled('div') `
  position: absolute;
  top: ${({ top }) => (top ? '30' : '0')}px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: rgba(255, 255, 255, 1);
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  height: ${({ active }) => (active ? 'auto' : '0px')};
  display: flex;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
`;
export const Wrapper = styled('div') `
  display: flex;
  align-items: flex-start;
  justify-content: safe center;
  flex-wrap: nowrap;
  padding-top: 12px;
  height: 100%;
  width: 100%;
  overflow-x: auto;
  padding-left: 24px;
  > div {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
      padding-right: 20px;
    }
  }
`;
export const Lists = styled('div') `
  position: relative;
  > div {
    margin-bottom: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
// LIST
export const List = styled('div') `
  position: relative;
  background: ${({ theme }) => theme.box.background};
  width: 320px;
  border-radius: 3px;
`;
export const ListHeading = styled('div') `
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 4px 16px;
  font-size: 14px;
  font-weight: 600;
  background: ${({ color }) => color};
  color: white;
  height: 32px;
  border-radius: 4px;
`;
export const HeadingDivider = styled('span') `
  margin-left: 8px;
  margin-right: 8px;
`;
export const ListHeadingCount = styled('div') `
  background: white;
  color: ${({ theme }) => theme.box.text};
  height: 16px;
  padding: 0 3px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 800;
  text-align: center;
`;
// ITEM
export const ListItems = styled('div') `
  position: relative;
  
  > div {
    border-bottom: 1px solid ${({ theme }) => theme.box.border};
    &:last-child {
      border-bottom: none;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }
  background: #f1f4f7;
`;
export const ListItem = styled('div') `
  padding: 12px;
  position: relative;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${({ theme }) => theme.box.background};
  ${({ isDragging }) => isDragging
    ? css `
          border-bottom: none !important;
          ${CS.shadow.heavy.one};
        `
    : ''};
  ${({ active }) => active
    ? css `
          border: 1px solid #fb2f2f !important;
          color: #fb2f2f;
        `
    : ''};
  &:hover {
    > .row-hover {
      visibility: visible;
      max-height: 50px;
    }
  }
  margin-bottom: 16px;
  border-radius: 4px;
`;
export const ListItemContent = styled('div') `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
export const ListItemHover = styled('div') `
  visibility: hidden;
  transition: 0.3s max-height;
  height: auto;
  max-height: 0;
`;
export const ListItemDropdown = styled('div') `
  border-top: 1px solid ${({ theme }) => theme.box.border};
`;
export const ListItemCover = styled('div') `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: rgba(255, 255, 255, 1);
`;
export const ListItemIcon = styled('div') `
  font-size: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const ListItemIconWrapper = styled('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ListItemEmpty = styled('div') `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 173px;
  gap: 16px;
`;
export const ItemEmptyIconWrapper = styled('div') `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 50%;
  background: #DFDFDF;
`;
const DotsHorizontalWrapper = styled('div') `
  svg {
    cursor: pointer;
  }
`;
export const DotsHorizontal = ({ onClick }) => {
    return (React.createElement(DotsHorizontalWrapper, { onClick: onClick },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M16 12a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-6 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m-6 0a2 2 0 0 1 2-2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2" }))));
};
export const EmptyCheckbox = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none" },
        React.createElement("path", { d: "M5.33325 21C4.78325 21 4.31225 20.804 3.92025 20.412C3.52825 20.02 3.33259 19.5493 3.33325 19V5C3.33325 4.45 3.52925 3.979 3.92125 3.587C4.31325 3.195 4.78392 2.99934 5.33325 3H19.3333C19.8833 3 20.3543 3.196 20.7463 3.588C21.1383 3.98 21.3339 4.45067 21.3333 5V19C21.3333 19.55 21.1373 20.021 20.7453 20.413C20.3533 20.805 19.8826 21.0007 19.3333 21H5.33325ZM5.33325 19H19.3333V5H5.33325V19Z", fill: "#6B7270" })));
};
export const Checkedbox = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none" },
        React.createElement("path", { d: "M10.9333 13.4L8.78325 11.25C8.59992 11.0667 8.36659 10.975 8.08325 10.975C7.79992 10.975 7.56659 11.0667 7.38325 11.25C7.19992 11.4333 7.10825 11.6667 7.10825 11.95C7.10825 12.2333 7.19992 12.4667 7.38325 12.65L10.2333 15.5C10.4333 15.7 10.6666 15.8 10.9333 15.8C11.1999 15.8 11.4333 15.7 11.6333 15.5L17.2833 9.85C17.4666 9.66667 17.5583 9.43333 17.5583 9.15C17.5583 8.86667 17.4666 8.63334 17.2833 8.45C17.0999 8.26667 16.8666 8.175 16.5833 8.175C16.2999 8.175 16.0666 8.26667 15.8833 8.45L10.9333 13.4ZM5.33325 21C4.78325 21 4.31225 20.804 3.92025 20.412C3.52825 20.02 3.33259 19.5493 3.33325 19V5C3.33325 4.45 3.52925 3.979 3.92125 3.587C4.31325 3.195 4.78392 2.99934 5.33325 3H19.3333C19.8833 3 20.3543 3.196 20.7463 3.588C21.1383 3.98 21.3339 4.45067 21.3333 5V19C21.3333 19.55 21.1373 20.021 20.7453 20.413C20.3533 20.805 19.8826 21.0007 19.3333 21H5.33325Z", fill: "#FB2F2F" })));
};
//# sourceMappingURL=components.js.map